const CATEGORIES = [
  {
    id: 'edr',
    label: 'Endpoint Security / EDR',
    vendors: [
      'CrowdStrike',
      'SentinelOne',
      'Palo Alto Networks',
      'Heimdal',
      'Panda',
      'ESET',
      'Microsoft',
      'Bitdefender',
      'Trend Micro',
      'Sophos',
    ],
    cost: 8500,
    hours: 6,
  },
  {
    id: 'email',
    label: 'Email Security',
    vendors: ['Proofpoint', 'Mimecast', 'Abnormal', 'Check Point', 'Microsoft'],
    cost: 6000,
    hours: 5,
  },
  {
    id: 'cloud',
    label: 'Cloud Security',
    vendors: ['Wiz', 'Windows Defender', 'Palo Alto Networks'],
    cost: 7200,
    hours: 4,
  },
  {
    id: 'mdm',
    label: 'Mobile Device Management',
    vendors: ['Microsoft (Intune)', 'Jamf'],
    cost: 4200,
    hours: 4,
  },
  {
    id: 'mdr',
    label: 'Monitoring / Response',
    vendors: ['Arctic Wolf', 'Expel', 'eSentire', 'Blackpoint', 'Huntress', 'N-able'],
    cost: 14000,
    hours: 8,
  },
  {
    id: 'dlp',
    label: 'Data Protection',
    vendors: [
      'Microsoft Purview',
      'Forcepoint',
      'Proofpoint',
      'Symantec',
      'Trellix',
      'Digital Guardian',
      'Cyberhaven',
    ],
    cost: 5500,
    hours: 4,
  },
  {
    id: 'sat',
    label: 'Security Awareness Training',
    vendors: ['KnowBe4', 'Proofpoint', 'Hoxhunt', 'Mimecast'],
    cost: 2400,
    hours: 2,
  },
  {
    id: 'net',
    label: 'Network Security',
    vendors: ['Fortinet', 'Palo Alto Networks', 'Check Point', 'Cisco'],
    cost: 6800,
    hours: 5,
  },
];

const CORO_MAP = {
  edr: {
    modules: 'Endpoint Security + Endpoint Detection & Response (add-on: WiFi Phishing)',
    url: 'https://www.coro.net/platform/modules#endpoint-protection',
    summary:
      'Coro\'s Endpoint Security module provides NGAV with device posture policies, ' +
      'allow/blocklists, advanced threat control and scheduled malware scans across ' +
      'Windows, macOS and Linux, while the EDR module adds behaviour-based real-time ' +
      'detection with device telemetry, process graphs and remediation tools. The ' +
      'WiFi Phishing add-on protects roaming devices from rogue access points.',
  },
  email: {
    modules: 'Email Security (add-ons: Secure Messages, Inbound Gateway)',
    url: 'https://www.coro.net/platform/modules#email-protection',
    summary:
      'Coro\'s Email Security module is API-based cloud email protection using ' +
      'LLM-driven detection to monitor, flag, quarantine and remediate phishing and ' +
      'malware, with real-time URL rewriting and inspection at click time, allow/block ' +
      'lists, auto-forward protection and end-user phishing reports. Secure Messages ' +
      'adds outbound email encryption; Inbound Gateway adds proxy-based inspection.',
  },
  cloud: {
    modules: 'Cloud App Security (add-on: Cloud Backup powered by Keepit)',
    url: 'https://www.coro.net/platform/modules#cloud-app-security',
    summary:
      'Coro\'s Cloud App Security module connects, monitors and controls Microsoft 365, ' +
      'Google Workspace, Slack, Dropbox, Box and Salesforce — with malware detection ' +
      'and quarantine, access permissions by user, group, country or IP, ' +
      'impossible-traveller detection and visibility over connected third-party apps. ' +
      'Cloud Backup adds immutable SaaS backups with granular restore.',
  },
  mdm: {
    modules: 'Mobile Device Management',
    url: 'https://www.coro.net/platform/modules#endpoint-protection',
    summary:
      'Coro\'s MDM module manages company-owned and BYOD mobile devices from the same ' +
      'Coro console — iOS/iPadOS enrolment via DEP, application policies, remote app ' +
      'installation, Lost Mode with location tracking, and remote wipe or disenrolment ' +
      'of compromised or inactive devices.',
  },
  mdr: {
    modules: 'Coro Platform + Managed Services',
    url: 'https://www.coro.net/platform/managed-services',
    summary:
      'The Coro platform automatically remediates around 95% of security incidents, ' +
      'collapsing alert volume so technicians only see what genuinely needs a human. ' +
      'Coro Managed Services adds Coro\'s analyst team monitoring endpoints, email, ' +
      'cloud apps and the network environment to investigate and resolve threats — ' +
      'managed SOC outcomes without building one.',
  },
  dlp: {
    modules: 'Endpoint Data Governance + User Data Governance',
    url: 'https://www.coro.net/platform/modules#data-protection',
    summary:
      'Coro\'s Endpoint Data Governance and User Data Governance modules detect and ' +
      'control sensitive data (PHI, PCI, PII, NPI) on devices and across email and ' +
      'file sharing — with an outbound gateway that blocks policy-violating emails in ' +
      'real time, scheduled and on-demand endpoint scans, access permissions and ' +
      'unified ticketing, supporting GDPR, HIPAA and PCI-DSS compliance.',
  },
  sat: {
    modules: 'Security Awareness Training',
    url: 'https://www.coro.net/platform/modules#sat',
    summary:
      'Coro\'s SAT module runs real-world phishing simulations, adaptive training ' +
      'personalised to each user\'s risk and behaviour, and focused video/quiz ' +
      'courses — with analytics covering simulation engagement, phishing failure ' +
      'rates and training completion.',
  },
  net: {
    modules: 'Network (add-on: Secure Web Gateway)',
    url: 'https://www.coro.net/platform/modules#network-protection',
    summary:
      'Coro\'s Network module creates a secure virtual office for distributed ' +
      'workforces with Zero Trust Network Access, enterprise and military-grade ' +
      'encrypted VPN, site-to-site tunnels and a mobile app for iOS and Android — ' +
      'replacing traditional firewall hardware. The Secure Web Gateway add-on ' +
      'applies DNS filtering with allow/block lists and per-label policies.',
  },
};

const HS_PREFIX = {
  edr: 'edr_',
  email: 'email_security_',
  cloud: 'cloud_security_',
  mdm: 'mdm_',
  mdr: 'monitoring_response_',
  dlp: 'data_protection_',
  sat: 'security_awareness_training_',
  net: 'network_security_',
};

const HS_PORTAL_ID = '145935794';
const HS_FORM_ID = '62c5f3b8-fcd3-4a3b-9eda-a729e4d015aa';
const HS_REGION = 'eu1';
const DRAFT_STORAGE_KEY = 'coro-roi-calculator-draft-v1';

const CORO_PACKAGE_HS = {
  '17': 'coro_ai_complete',
  '7.5': 'coro_ai_essentials',
  '5': 'coro_ai_endpoint',
  '5.001': 'coro_ai_lite',
  custom: 'custom_pricing',
};

function toHsSlug(label) {
  if (!label || label === '__other') {
    return 'other';
  }
  return String(label)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

const fmt = (n) =>
  n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

const byId = (id) => document.getElementById(id);

function qs(root, selector) {
  return root.querySelector(selector);
}

function qsa(root, selector) {
  return Array.from(root.querySelectorAll(selector));
}

function num(el) {
  return el ? Number(el.value) || 0 : 0;
}

function roundTo(n, places) {
  return Number(n || 0).toFixed(places);
}

function setMetric(el, val, good) {
  if (!el) {
    return;
  }
  el.classList.toggle('is-good', good);
  el.classList.toggle('is-bad', !good);
  const valEl = qs(el, '.coro-roi-calculator__metric-val');
  if (valEl) {
    valEl.textContent = val;
  }
}

function setFieldValue(el, value) {
  if (!el || value == null) {
    return;
  }
  el.value = String(value);
}

function collectDraft(root) {
  const rows = {};
  CATEGORIES.forEach((cat) => {
    const toggle = qs(root, `.coro-roi-calculator__toggle[data-id="${cat.id}"]`);
    const vendorEl = qs(root, `.coro-roi-calculator__vendor[data-id="${cat.id}"]`);
    const otherEl = qs(root, `.coro-roi-calculator__custom-vendor[data-id="${cat.id}"]`);
    const costEl = qs(root, `.coro-roi-calculator__cost[data-id="${cat.id}"]`);
    const hoursEl = qs(root, `.coro-roi-calculator__hours[data-id="${cat.id}"]`);
    const techsEl = qs(root, `.coro-roi-calculator__techs[data-id="${cat.id}"]`);
    rows[cat.id] = {
      on: !!(toggle && toggle.checked),
      vendor: vendorEl ? vendorEl.value : '',
      vendorOther: otherEl ? otherEl.value : '',
      cost: costEl ? costEl.value : '',
      hours: hoursEl ? hoursEl.value : '',
      techs: techsEl ? techsEl.value : '',
    };
  });

  const rateEl = byId('coro-roi-rate');
  const usersEl = byId('coro-roi-users');
  const pkgEl = byId('coro-roi-pkg');
  const coroCostEl = byId('coro-roi-cost');

  return {
    version: 1,
    rate: rateEl ? rateEl.value : '',
    users: usersEl ? usersEl.value : '',
    pkg: pkgEl ? pkgEl.value : '',
    coroCost: coroCostEl ? coroCostEl.value : '',
    rows,
  };
}

function saveDraft(root) {
  try {
    window.localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(collectDraft(root)));
  } catch (_e) {
    // Ignore quota / private mode failures.
  }
}

function restoreDraft(root) {
  let draft;
  try {
    const raw = window.localStorage.getItem(DRAFT_STORAGE_KEY);
    if (!raw) {
      return false;
    }
    draft = JSON.parse(raw);
  } catch (_e) {
    return false;
  }

  if (!draft || draft.version !== 1 || typeof draft !== 'object') {
    return false;
  }

  setFieldValue(byId('coro-roi-rate'), draft.rate);
  setFieldValue(byId('coro-roi-users'), draft.users);

  const pkgEl = byId('coro-roi-pkg');
  if (pkgEl && draft.pkg != null && draft.pkg !== '') {
    const match = Array.from(pkgEl.options).find((opt) => opt.value === String(draft.pkg));
    if (match) {
      pkgEl.value = match.value;
    }
  }

  if (draft.rows && typeof draft.rows === 'object') {
    CATEGORIES.forEach((cat) => {
      const row = draft.rows[cat.id];
      if (!row) {
        return;
      }
      const toggle = qs(root, `.coro-roi-calculator__toggle[data-id="${cat.id}"]`);
      const vendorEl = qs(root, `.coro-roi-calculator__vendor[data-id="${cat.id}"]`);
      const otherEl = qs(root, `.coro-roi-calculator__custom-vendor[data-id="${cat.id}"]`);
      const costEl = qs(root, `.coro-roi-calculator__cost[data-id="${cat.id}"]`);
      const hoursEl = qs(root, `.coro-roi-calculator__hours[data-id="${cat.id}"]`);
      const techsEl = qs(root, `.coro-roi-calculator__techs[data-id="${cat.id}"]`);

      if (toggle) {
        toggle.checked = !!row.on;
      }
      if (vendorEl && row.vendor) {
        const match = Array.from(vendorEl.options).find((opt) => opt.value === String(row.vendor));
        if (match) {
          vendorEl.value = match.value;
        }
      }
      setFieldValue(otherEl, row.vendorOther);
      if (otherEl) {
        otherEl.hidden = !(vendorEl && vendorEl.value === '__other');
      }
      setFieldValue(costEl, row.cost);
      setFieldValue(hoursEl, row.hours);
      setFieldValue(techsEl, row.techs);
    });
  }

  syncCoroCost();
  if (pkgEl && pkgEl.value === 'custom') {
    setFieldValue(byId('coro-roi-cost'), draft.coroCost);
    updateMonthlyCoroCost();
  }

  return true;
}

function getState(root) {
  const rate = num(byId('coro-roi-rate'));
  const users = num(byId('coro-roi-users'));
  const rows = {};
  let tools = 0;
  let techHours = 0;
  let active = 0;

  CATEGORIES.forEach((cat) => {
    const toggle = qs(root, `.coro-roi-calculator__toggle[data-id="${cat.id}"]`);
    const vendorEl = qs(root, `.coro-roi-calculator__vendor[data-id="${cat.id}"]`);
    const otherEl = qs(root, `.coro-roi-calculator__custom-vendor[data-id="${cat.id}"]`);
    const costEl = qs(root, `.coro-roi-calculator__cost[data-id="${cat.id}"]`);
    const hoursEl = qs(root, `.coro-roi-calculator__hours[data-id="${cat.id}"]`);
    const techsEl = qs(root, `.coro-roi-calculator__techs[data-id="${cat.id}"]`);
    const on = !!(toggle && toggle.checked);
    const cost = num(costEl);
    const hours = num(hoursEl);
    const techs = num(techsEl);
    const humanCost = on ? hours * techs * 12 * rate : 0;
    const vendor = vendorEl ? vendorEl.value : '';
    const vendorOther = otherEl ? otherEl.value.trim() : '';

    rows[cat.id] = {
      on,
      vendor,
      vendorOther,
      cost: on ? cost : 0,
      hours: on ? hours : 0,
      techs: on ? techs : 0,
      humanCost,
      enteredCost: cost,
      enteredHours: hours,
      enteredTechs: techs,
    };

    if (on) {
      tools += cost;
      techHours += hours * techs;
      active += 1;
    }
  });

  tools *= users;
  const humanCost = techHours * 12 * rate;
  const currentTotal = tools + humanCost;
  const coroCost = num(byId('coro-roi-cost'));
  const coroHrs = Number((techHours / 3).toFixed(1));
  const coroHuman = Number((coroHrs * 12 * rate).toFixed(2));
  const coroTotal = Number((coroCost + coroHuman).toFixed(2));
  const savings = Number((currentTotal - coroTotal).toFixed(2));
  const roi = coroTotal > 0 ? (savings / coroTotal) * 100 : 0;
  const freedMo = Number(Math.max(0, techHours - coroHrs).toFixed(1));
  const pkgEl = byId('coro-roi-pkg');
  const pkgLabel = pkgEl && pkgEl.selectedOptions[0] ? pkgEl.selectedOptions[0].text : '';
  const pkgValue = pkgEl ? pkgEl.value : '';

  return {
    rate,
    users,
    rows,
    tools,
    techHours,
    humanCost,
    currentTotal,
    coroCost,
    coroHrs,
    coroHuman,
    coroTotal,
    savings,
    roi,
    freedMo,
    active,
    pkgLabel,
    pkgValue,
  };
}

function collectPayload(root) {
  const s = getState(root);
  const payload = {
    admin_hourly_rate: roundTo(s.rate, 2),
    licensed_users: Math.round(s.users),
    coro_package: CORO_PACKAGE_HS[s.pkgValue] || 'custom_pricing',
    coro_annual_cost: roundTo(s.coroCost, 2),
    monthly_cost: roundTo(s.coroCost / 12, 2),
    coro_admin_hours: roundTo(s.coroHrs, 1),
    coro_total_cost: roundTo(s.coroTotal, 2),
    coro_modules_replaced: Math.round(s.active),
    coro_admin_cost_note: roundTo(s.coroHuman, 2),
    current_tools_subtotal: roundTo(s.tools, 2),
    current_people_subtotal: roundTo(s.humanCost, 2),
    current_tech_hours_per_month: roundTo(s.techHours, 1),
    current_stack_total: roundTo(s.currentTotal, 2),
    net_savings_annual: roundTo(s.savings, 2),
    total_roi_percent: Math.round(s.roi),
    efficiency_gained_hours: roundTo(s.techHours / 3, 1),
    bar_current_amount: roundTo(s.currentTotal, 2),
    bar_coro_amount: roundTo(s.coroTotal, 2),
    tech_hours_current: roundTo(s.techHours, 1),
    tech_hours_coro: roundTo(s.coroHrs, 1),
    hours_freed_per_month: roundTo(s.freedMo, 1),
    hours_freed_per_year: Math.round(s.freedMo * 12),
    freed_capacity_value: roundTo(s.freedMo * 12 * s.rate, 2),
    capacity_multiplier: s.coroHrs > 0 ? roundTo(s.techHours / s.coroHrs, 1) : 0,
  };

  CATEGORIES.forEach((cat) => {
    const prefix = HS_PREFIX[cat.id];
    const row = s.rows[cat.id];
    payload[`${prefix}included`] = row.on ? 'true' : 'false';
    payload[`${prefix}vendor`] = toHsSlug(row.vendor);
    payload[`${prefix}vendor_other`] = row.vendor === '__other' ? row.vendorOther : '';
    payload[`${prefix}annual_cost_per_user`] = roundTo(row.cost, 2);
    payload[`${prefix}admin_hours_per_month`] = roundTo(row.hours, 1);
    payload[`${prefix}technicians`] = Math.round(row.techs);
    payload[`${prefix}human_cost`] = roundTo(row.humanCost, 2);
  });

  return payload;
}

const HS_VISIBLE_FIELDS = new Set([
  'email',
  'firstname',
  'lastname',
  'company',
  'countrydropdown',
  'state_dropdown',
  'consent_to_contact',
]);

const HS_ALWAYS_HIDDEN_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_id',
  'utm_content',
  'utm_term',
  'gclid__c',
  'fbclid__c',
  'twclid',
  'li_fat_id',
  'gspk__c',
  'gsxid__c',
  'msclkid',
  'rdt_cid',
];

function injectHiddenFieldCss(payload) {
  if (document.getElementById('coro-roi-hs-hide')) {
    return;
  }

  const names = Array.from(
    new Set([...Object.keys(payload), ...HS_ALWAYS_HIDDEN_FIELDS]),
  ).filter((name) => !HS_VISIBLE_FIELDS.has(name));

  const selectors = names
    .map((name) => `#coro-roi-hs-form .hs_${name}`)
    .join(',\n');

  const style = document.createElement('style');
  style.id = 'coro-roi-hs-hide';
  const visibleFieldsetKeepers = [
    '.hs_email',
    '.hs_firstname',
    '.hs_lastname',
    '.hs_company',
    '.hs_countrydropdown',
    '.hs_state_dropdown',
    '.hs_consent_to_contact',
    '.hs_submit',
    '.hs-submit',
  ].join(', ');

  style.textContent = `
${selectors} {
  display: none !important;
}
#coro-roi-hs-form fieldset:not(:has(${visibleFieldsetKeepers})) {
  display: none !important;
}
`.trim();
  document.head.appendChild(style);
}

function getHsFormInstance() {
  const HS = window.HubSpotFormsV4 || window.HubSpotForms;
  if (!HS) {
    return null;
  }
  if (typeof HS.getForms === 'function') {
    const forms = HS.getForms() || [];
    const match = forms.find((form) => {
      try {
        return typeof form.getFormId === 'function' && form.getFormId() === HS_FORM_ID;
      } catch (_e) {
        return false;
      }
    });
    if (match) {
      return match;
    }
    if (forms.length === 1) {
      return forms[0];
    }
  }
  const wrap = document.querySelector('#coro-roi-hs-form [data-instance-id]');
  const id = wrap && wrap.getAttribute('data-instance-id');
  if (id && typeof HS.getFormByInstanceId === 'function') {
    return HS.getFormByInstanceId(id);
  }
  return null;
}

function valueProto(field) {
  if (field.tagName === 'TEXTAREA') {
    return window.HTMLTextAreaElement.prototype;
  }
  if (field.tagName === 'SELECT') {
    return window.HTMLSelectElement.prototype;
  }
  return window.HTMLInputElement.prototype;
}

function writeInputValue(field, str) {
  const setter = Object.getOwnPropertyDescriptor(valueProto(field), 'value');
  const previous = field.value;
  if (field._valueTracker && typeof field._valueTracker.setValue === 'function') {
    field._valueTracker.setValue(previous === str ? `${str} ` : previous);
  }
  if (setter && setter.set) {
    setter.set.call(field, str);
  } else {
    field.value = str;
  }
  field.setAttribute('value', str);
  if (field.type === 'number' || field.getAttribute('inputmode') === 'decimal') {
    field.step = 'any';
    field.setAttribute('step', 'any');
  }
}

function toHsSafeValue(value) {
  if (value == null) {
    return '';
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  const asString = String(value);
  if (asString === '' || Number.isNaN(Number(asString)) || !/^-?\d/.test(asString.trim())) {
    return asString;
  }
  const n = Number(asString);
  if (!Number.isFinite(n)) {
    return asString;
  }
  if (Number.isInteger(n)) {
    return String(Math.round(n));
  }
  return n.toFixed(1);
}

let applyingHsFields = false;

function pushHsValue(instance, name, str) {
  if (!instance || typeof instance.setFieldValue !== 'function' || !name) {
    return;
  }
  const asNum = Number(str);
  const useNumber = str !== '' && Number.isFinite(asNum) && /^-?\d+(\.\d+)?$/.test(str);
  [name, `0-1/${name}`].forEach((fieldName) => {
    try {
      // Prefer the rounded string for decimals so HubSpot keeps "12.7", not 38/3.
      instance.setFieldValue(fieldName, useNumber && str.indexOf('.') === -1 ? asNum : str);
    } catch (_e) {
      // Ignore fields this instance does not expose.
    }
  });
}

function writeDomField(scope, name, str) {
  const fields = qsa(scope, `[name="${name}"], [name="${name}[]"]`);
  if (!fields.length) {
    return false;
  }

  fields.forEach((field) => {
    if (field.type === 'checkbox' || field.type === 'radio') {
      const on = field.value === str ||
        ((str === 'true' || str === '1') && (field.value === 'true' || field.value === '1' || field.value === 'on'));
      field.checked = on;
      return;
    }
    writeInputValue(field, str);
  });
  return true;
}

function forceHsField(scope, instance, name, str) {
  pushHsValue(instance, name, str);
  writeDomField(scope, name, str);
}

function clampLongDecimalInputs(scope, instance) {
  if (!scope || typeof scope.querySelectorAll !== 'function' || applyingHsFields) {
    return;
  }
  scope.querySelectorAll('input[type="number"], input[inputmode="decimal"]').forEach((field) => {
    const raw = field.value;
    if (!raw || raw.indexOf('.') === -1) {
      return;
    }
    if ((raw.split('.')[1] || '').length <= 2) {
      return;
    }
    const n = Number(raw);
    if (!Number.isFinite(n) || !field.name) {
      return;
    }
    const str = n.toFixed(1);
    forceHsField(scope, instance, field.name, str);
  });
}

function setFormFields(form, payload) {
  const root = document.getElementById('coro-roi-hs-form') ||
    (form && form.jquery ? form.get(0) : form);
  if (!root || typeof root.querySelector !== 'function') {
    return false;
  }

  const instance = getHsFormInstance();
  let wrote = 0;

  applyingHsFields = true;
  try {
    Object.keys(payload).forEach((name) => {
      const str = toHsSafeValue(payload[name]);
      forceHsField(root, instance, name, str);
      if (root.querySelector(`[name="${name}"], [name="${name}[]"]`)) {
        wrote += 1;
      }
    });
    clampLongDecimalInputs(root, instance);
  } finally {
    applyingHsFields = false;
  }

  return wrote > 0;
}

function watchHsFormFill(root, getPayload) {
  const target = byId('coro-roi-hs-form');
  if (!target || target.dataset.coroRoiFillWatch === '1') {
    return;
  }
  target.dataset.coroRoiFillWatch = '1';

  const apply = () => {
    if (applyingHsFields) {
      return;
    }
    setFormFields(target, getPayload());
  };

  const observer = new MutationObserver(() => {
    window.setTimeout(apply, 0);
  });
  observer.observe(target, { childList: true, subtree: true });

  let ticks = 0;
  const timer = window.setInterval(() => {
    ticks += 1;
    apply();
    clampLongDecimalInputs(target, getHsFormInstance());
    if (ticks >= 40) {
      window.clearInterval(timer);
      observer.disconnect();
    }
  }, 250);

  target.addEventListener(
    'submit',
    () => {
      apply();
      clampLongDecimalInputs(target, getHsFormInstance());
      window.clearInterval(timer);
      observer.disconnect();
    },
    true,
  );
}

function isHsFormEvent(event) {
  return !!(event.target && event.target.closest &&
    event.target.closest('#coro-roi-hs-form'));
}

function waitForHsForms(cb) {
  if (window.hbspt && window.hbspt.forms) {
    cb();
    return;
  }
  let tries = 0;
  const timer = window.setInterval(() => {
    tries += 1;
    if (window.hbspt && window.hbspt.forms) {
      window.clearInterval(timer);
      cb();
    } else if (tries > 80) {
      window.clearInterval(timer);
    }
  }, 50);
}

let resultsRevealed = false;

function lockCalculatorInputs(calculator) {
  if (!calculator) {
    return;
  }
  calculator.classList.add('is-locked');
  qsa(calculator, 'input, select, textarea, button').forEach((el) => {
    if (el.classList.contains('coro-roi-calculator__info-btn')) {
      return;
    }
    if (el.id === 'coro-roi-calculate') {
      el.disabled = true;
      return;
    }
    if (el.tagName === 'SELECT' || el.type === 'checkbox' || el.type === 'radio' ||
      el.type === 'button' || el.type === 'submit') {
      el.disabled = true;
      return;
    }
    el.readOnly = true;
    el.disabled = true;
  });
}

function revealResults() {
  if (resultsRevealed) {
    return;
  }
  resultsRevealed = true;

  const formWrap = byId('coro-roi-form-wrap');
  if (formWrap) {
    formWrap.hidden = true;
  }

  const calculator = document.querySelector('[data-coro-roi-calculator]');
  if (calculator) {
    calculator.classList.add('is-results-open');
    lockCalculatorInputs(calculator);
  }

  ['coro-roi-tco', 'coro-roi-annual', 'coro-roi-capacity'].forEach((id) => {
    const el = byId(id);
    if (el) {
      el.hidden = false;
    }
  });

  const tco = byId('coro-roi-tco');
  if (tco && tco.scrollIntoView) {
    tco.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function watchHsSuccess(container) {
  if (!container || container.dataset.coroRoiSuccessWatch === '1') {
    return;
  }
  container.dataset.coroRoiSuccessWatch = '1';

  const maybeReveal = () => {
    if (container.querySelector('.submitted-message')) {
      window.setTimeout(revealResults, 300);
      return true;
    }
    return false;
  };

  if (maybeReveal()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (maybeReveal()) {
      observer.disconnect();
    }
  });
  observer.observe(container, { childList: true, subtree: true });
}

function updateMonthlyCoroCost() {
  const cost = byId('coro-roi-cost');
  const monthly = byId('coro-roi-cost-monthly');
  if (!monthly) {
    return;
  }
  const raw = cost && cost.value !== '' ? Number(cost.value) : NaN;
  if (!Number.isFinite(raw) || raw < 0) {
    monthly.value = '';
    return;
  }
  monthly.value = Math.round((raw / 12) * 100) / 100;
}

function syncCoroCost() {
  if (resultsRevealed) {
    return;
  }
  const sel = byId('coro-roi-pkg');
  const cost = byId('coro-roi-cost');
  if (!sel || !cost) {
    return;
  }
  if (sel.value === 'custom') {
    cost.readOnly = false;
    cost.style.opacity = '1';
    cost.placeholder = '—';
    updateMonthlyCoroCost();
    return;
  }
  cost.readOnly = true;
  cost.style.opacity = '0.85';
  cost.placeholder = '—';
  if (!sel.value) {
    cost.value = '';
    updateMonthlyCoroCost();
    return;
  }
  const users = num(byId('coro-roi-users'));
  if (!users) {
    cost.value = '';
    updateMonthlyCoroCost();
    return;
  }
  cost.value = Math.round(parseFloat(sel.value) * users * 12 * 100) / 100;
  updateMonthlyCoroCost();
}

function clearValidation(root) {
  qsa(root, '.is-invalid').forEach((el) => {
    el.classList.remove('is-invalid');
  });
  const err = byId('coro-roi-form-error');
  if (err) {
    err.hidden = true;
    err.textContent = '';
  }
}

function markInvalid(el) {
  if (el) {
    el.classList.add('is-invalid');
  }
}

function hasPositiveNumber(el) {
  return !!(el && el.value !== '' && Number(el.value) > 0);
}

function hasNonNegativeNumber(el) {
  return !!(el && el.value !== '' && Number(el.value) >= 0);
}

function collectValidationErrors(root) {
  const errors = [];
  const invalid = [];

  const mark = (el, message) => {
    if (el) {
      invalid.push(el);
    }
    errors.push(message);
  };

  const rateEl = byId('coro-roi-rate');
  const usersEl = byId('coro-roi-users');
  const pkgEl = byId('coro-roi-pkg');
  const coroCostEl = byId('coro-roi-cost');

  if (!hasPositiveNumber(rateEl)) {
    mark(rateEl, 'Enter your IT admin hourly rate.');
  }
  if (!usersEl || usersEl.value === '' || Number(usersEl.value) < 1) {
    mark(usersEl, 'Enter the number of licensed users (at least 1).');
  }
  if (!pkgEl || !pkgEl.value) {
    mark(pkgEl, 'Select a Coro package.');
  } else if (pkgEl.value === 'custom' && !hasPositiveNumber(coroCostEl)) {
    mark(coroCostEl, 'Enter a custom Coro annual platform cost.');
  }

  let enabledCount = 0;
  CATEGORIES.forEach((cat) => {
    const toggle = qs(root, `.coro-roi-calculator__toggle[data-id="${cat.id}"]`);
    if (!toggle || !toggle.checked) {
      return;
    }
    enabledCount += 1;

    const vendorEl = qs(root, `.coro-roi-calculator__vendor[data-id="${cat.id}"]`);
    const otherEl = qs(root, `.coro-roi-calculator__custom-vendor[data-id="${cat.id}"]`);
    const costEl = qs(root, `.coro-roi-calculator__cost[data-id="${cat.id}"]`);
    const hoursEl = qs(root, `.coro-roi-calculator__hours[data-id="${cat.id}"]`);
    const techsEl = qs(root, `.coro-roi-calculator__techs[data-id="${cat.id}"]`);

    if (!vendorEl || !vendorEl.value) {
      mark(vendorEl, `${cat.label}: select a product.`);
    } else if (vendorEl.value === '__other' && !(otherEl && otherEl.value.trim())) {
      mark(otherEl, `${cat.label}: enter the vendor name.`);
    }
    if (!hasPositiveNumber(costEl)) {
      mark(costEl, `${cat.label}: enter annual cost per user.`);
    }
    if (!hasNonNegativeNumber(hoursEl)) {
      mark(hoursEl, `${cat.label}: enter admin hours per month.`);
    }
    if (!techsEl || techsEl.value === '' || Number(techsEl.value) < 1) {
      mark(techsEl, `${cat.label}: enter number of technicians (at least 1).`);
    }
  });

  if (enabledCount === 0) {
    errors.push('Enable at least one threat vector and fill in its details.');
  }

  return { errors, invalid };
}

function syncValidationFeedback(root) {
  const err = byId('coro-roi-form-error');
  if (!err || err.hidden) {
    return;
  }
  const { errors } = collectValidationErrors(root);
  if (!errors.length) {
    clearValidation(root);
  }
}

function validateForCalculate(root) {
  clearValidation(root);
  const { errors, invalid } = collectValidationErrors(root);
  invalid.forEach(markInvalid);

  if (!errors.length) {
    return true;
  }

  const err = byId('coro-roi-form-error');
  if (err) {
    err.hidden = false;
    err.textContent = errors.length === 1
      ? errors[0]
      : `${errors[0]} (+${errors.length - 1} more)`;
  }
  const firstInvalid = invalid[0] || qs(root, '.is-invalid');
  if (firstInvalid) {
    if (typeof firstInvalid.focus === 'function') {
      firstInvalid.focus();
    }
    if (typeof firstInvalid.scrollIntoView === 'function') {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  return false;
}

function recalc(root) {
  const s = getState(root);

  CATEGORIES.forEach((cat) => {
    const row = byId(`coro-roi-row-${cat.id}`);
    const on = s.rows[cat.id].on;
    if (row) {
      row.classList.toggle('is-off', !on);
      if (!resultsRevealed) {
        qsa(row, 'select,input:not(.coro-roi-calculator__toggle)').forEach((el) => {
          el.disabled = !on;
        });
      }
    }
    const humanEl = byId(`coro-roi-human-${cat.id}`);
    if (humanEl) {
      const hrs = s.rows[cat.id].enteredHours;
      const techs = s.rows[cat.id].enteredTechs;
      humanEl.textContent = fmt(hrs * techs * 12 * s.rate);
    }
  });

  const coroHours = byId('coro-roi-hours');
  if (coroHours) {
    coroHours.value = s.techHours > 0 ? Math.round(s.coroHrs * 10) / 10 : '';
  }

  const max = Math.max(s.currentTotal, s.coroTotal, 1);

  byId('coro-roi-sum-tools').textContent = fmt(s.tools);
  byId('coro-roi-sum-people').textContent = fmt(s.humanCost);
  byId('coro-roi-sum-hours').textContent =
    `(${s.techHours} tech-hrs/mo — Σ hours × technicians per row)`;
  byId('coro-roi-sum-total').textContent = fmt(s.currentTotal);
  byId('coro-roi-eyebrow').textContent =
    `With Coro — one platform, ${s.active} modules replaced`;
  byId('coro-roi-coro-total').textContent = fmt(s.coroTotal);
  byId('coro-roi-coro-human').textContent = `incl. ${fmt(s.coroHuman)} admin time`;

  setMetric(byId('coro-roi-m-savings'), fmt(s.savings), s.savings >= 0);
  setMetric(byId('coro-roi-m-roi'), `${s.roi.toFixed(0)}%`, s.roi >= 0);
  setMetric(byId('coro-roi-m-hours'), `${(s.techHours / 3).toFixed(1)} hrs/mo`, true);

  setMetric(byId('coro-roi-m-hrs-cur'), `${s.techHours.toFixed(1)} hrs/mo`, false);
  setMetric(byId('coro-roi-m-hrs-coro'), `${s.coroHrs.toFixed(1)} hrs/mo`, true);
  setMetric(byId('coro-roi-m-hrs-freed'), `${s.freedMo.toFixed(1)} hrs/mo`, true);
  byId('coro-roi-freed-yr').textContent = `${Math.round(s.freedMo * 12).toLocaleString()} hrs`;
  byId('coro-roi-freed-val').textContent = fmt(s.freedMo * 12 * s.rate);
  byId('coro-roi-cap-mult').textContent =
    s.coroHrs > 0 ? `${(s.techHours / s.coroHrs).toFixed(1)}\u00d7` : '\u2014';

  byId('coro-roi-bar-cur-amt').textContent = fmt(s.currentTotal);
  byId('coro-roi-bar-coro-amt').textContent = fmt(s.coroTotal);
  byId('coro-roi-bar-cur').style.width = `${Math.max(4, (s.currentTotal / max) * 100)}%`;
  byId('coro-roi-bar-coro').style.width = `${Math.max(4, (s.coroTotal / max) * 100)}%`;
}

function buildRows() {
  const rowsEl = byId('coro-roi-rows');
  if (!rowsEl) {
    return;
  }

  CATEGORIES.forEach((cat) => {
    const row = document.createElement('div');
    row.className = 'coro-roi-calculator__grid-row';
    row.id = `coro-roi-row-${cat.id}`;

    const vendorOptions = cat.vendors
      .map((vendor) => `<option value="${vendor}">${vendor}</option>`)
      .join('');

    row.innerHTML = `
      <div>
        <input type="checkbox" checked data-id="${cat.id}"
          class="coro-roi-calculator__toggle" aria-label="${cat.label}">
      </div>
      <div class="coro-roi-calculator__cat">
        ${cat.label}
        <button type="button" class="coro-roi-calculator__info-btn"
          data-info="${cat.id}" title="What Coro provides here">i</button>
      </div>
      <div class="coro-roi-calculator__cell">
        <select data-id="${cat.id}" class="coro-roi-calculator__vendor" required>
          <option value="" selected disabled>Select</option>
          ${vendorOptions}
          <option value="__other">Other…</option>
        </select>
        <input type="text" class="coro-roi-calculator__txt coro-roi-calculator__custom-vendor"
          data-id="${cat.id}" placeholder="Vendor name" hidden>
      </div>
      <div class="coro-roi-calculator__cell">
        <div class="coro-roi-calculator__money">
          <span>$</span>
          <input type="number" min="0" step="any" value="" data-id="${cat.id}"
            class="coro-roi-calculator__cost" placeholder="0" required>
        </div>
      </div>
      <div class="coro-roi-calculator__cell">
        <input type="number" min="0" step="any" value="" data-id="${cat.id}"
          class="coro-roi-calculator__hours coro-roi-calculator__hours-input"
          placeholder="0" required>
      </div>
      <div class="coro-roi-calculator__hours-cell">
        <input type="number" min="1" step="1" value="" data-id="${cat.id}"
          class="coro-roi-calculator__techs" placeholder="0" required>
        <span class="coro-roi-calculator__row-human">
          = <strong id="coro-roi-human-${cat.id}">$0</strong>/yr
        </span>
      </div>`;
    rowsEl.appendChild(row);

    const summary = document.createElement('div');
    summary.className = 'coro-roi-calculator__summary';
    summary.id = `coro-roi-summary-${cat.id}`;
    const map = CORO_MAP[cat.id];
    summary.innerHTML =
      `<strong>Coro module(s): ${map.modules}.</strong> ${map.summary} ` +
      `<a href="${map.url}" target="_blank" rel="noopener">View on coro.net →</a>`;
    rowsEl.appendChild(summary);
  });
}

function createHubSpotForm(root) {
  const target = byId('coro-roi-hs-form');
  if (!target || target.dataset.hsCreated === '1') {
    return;
  }
  target.dataset.hsCreated = '1';
  injectHiddenFieldCss(collectPayload(root));

  const getPayload = () => collectPayload(root);
  watchHsFormFill(root, getPayload);
  watchHsSuccess(target);

  waitForHsForms(() => {
    window.hbspt.forms.create({
      portalId: HS_PORTAL_ID,
      formId: HS_FORM_ID,
      region: HS_REGION,
      target: '#coro-roi-hs-form',
      onFormReady: ($form) => {
        const apply = () => setFormFields($form, getPayload());
        apply();
        [50, 150, 300, 600, 1200, 2000].forEach((ms) => window.setTimeout(apply, ms));
      },
      onBeforeFormSubmit: ($form) => {
        setFormFields($form, getPayload());
      },
      onFormSubmitted: () => {
        // Wait until HubSpot finishes its thank-you render, then hide form + show report.
        window.setTimeout(revealResults, 300);
      },
    });
  });

  window.addEventListener('hs-form-event:on-submission:success', (event) => {
    const detail = event.detail || {};
    if (detail.formId !== HS_FORM_ID) {
      return;
    }
    window.setTimeout(revealResults, 300);
  });
}

function initCalculator(root) {
  buildRows();
  restoreDraft(root);

  root.addEventListener('click', (e) => {
    const infoBtn = e.target.closest('.coro-roi-calculator__info-btn');
    if (infoBtn) {
      const summary = byId(`coro-roi-summary-${infoBtn.dataset.info}`);
      if (summary) {
        summary.classList.toggle('is-open');
      }
    }
  });

  root.addEventListener('input', (e) => {
    if (resultsRevealed || isHsFormEvent(e) || applyingHsFields) {
      return;
    }
    if (e.target.classList.contains('is-invalid')) {
      e.target.classList.remove('is-invalid');
    }
    if (e.target.id === 'coro-roi-pkg' || e.target.id === 'coro-roi-users') {
      syncCoroCost();
    }
    if (e.target.id === 'coro-roi-cost') {
      updateMonthlyCoroCost();
    }
    if (e.target.classList.contains('coro-roi-calculator__vendor')) {
      const custom = qs(
        root,
        `.coro-roi-calculator__custom-vendor[data-id="${e.target.dataset.id}"]`,
      );
      if (custom) {
        custom.hidden = e.target.value !== '__other';
      }
    }
    recalc(root);
    syncValidationFeedback(root);
  });

  root.addEventListener('change', (e) => {
    if (resultsRevealed || isHsFormEvent(e) || applyingHsFields) {
      return;
    }
    if (e.target.classList.contains('is-invalid')) {
      e.target.classList.remove('is-invalid');
    }
    if (e.target.id === 'coro-roi-pkg' || e.target.id === 'coro-roi-users') {
      syncCoroCost();
    }
    recalc(root);
    syncValidationFeedback(root);
  });

  const calcBtn = byId('coro-roi-calculate');
  if (calcBtn) {
    calcBtn.addEventListener('click', () => {
      if (!validateForCalculate(root)) {
        return;
      }
      saveDraft(root);
      const wrap = byId('coro-roi-form-wrap');
      if (wrap) {
        wrap.hidden = false;
      }
      calcBtn.hidden = true;
      const actions = qs(root, '.coro-roi-calculator__actions');
      if (actions) {
        actions.hidden = true;
      }
      createHubSpotForm(root);
      if (wrap) {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  syncCoroCost();
  recalc(root);
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-coro-roi-calculator]');
  if (root) {
    initCalculator(root);
  }
});
